import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import TextField from './TextField';
import FormikPropsValidations from './FormikPropsValidations';
import _isFunction from 'lodash/isFunction';
import _get from 'lodash/get';
import { PHONE_COUNTRY_CODES } from './../../../constants/constants';

export class PhoneField extends PureComponent {
  static propTypes = {
    name: props => FormikPropsValidations('name', props),
    value: PropTypes.oneOfType([PropTypes.string]),
    label: PropTypes.string,
    onChange: props => FormikPropsValidations('onChange', props),
    validateField: PropTypes.func,
    placeholder: PropTypes.string,
    form: PropTypes.object,
    country: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      countryCode: this._getCountryCode(),
      fieldName: this.props.name || _get(this.props, 'field.name')
    };
  }

  componentDidMount() {
    this.setState({ countryCode: this._getCountryCode() });
  }
  trimPhoneNumber = phoneNumber => {
    const { countryCode } = this.state;
    const prefixLength = countryCode.length === 1 ? 1 : countryCode.length;
    if (phoneNumber) {
      return phoneNumber.substring(prefixLength);
    }
    return '';
  };
  componentDidUpdate(prevProps) {
    const { country, form = {} } = this.props;
    const { fieldName } = this.state;
    const countryCode = this._getCountryCode();

    if (prevProps.country !== country) {
      if (_isFunction(form.setFieldValue)) {
        form.setFieldValue(fieldName, '');
      }
    }
    this.setState({ countryCode });
  }
  _getCountryCode = () => {
    return PHONE_COUNTRY_CODES[this.props.country];
  };
  _handleValidateField = (currentField, currentValue) => {
    const { validateField } = this.props;
    const { countryCode } = this.state;
    if (_isFunction(validateField)) {
      // If the user has not entered a phone number don't validate just the country code
      const fullPhoneNumber = currentValue
        ? `${countryCode}${currentValue}`
        : null;
      validateField(currentField, fullPhoneNumber);
    }
  };
  _handleChange = ({ target: { name, value } }) => {
    const { countryCode } = this.state;
    // If the user is clearing out the phone number, we need to remove the country code
    const fullPhoneNumber = value ? `${countryCode}${value}` : null;
    this.props.onChange({ target: { name, value: fullPhoneNumber } });
  };
  render() {
    const { country, label, form, field, value, disabled = false } = this.props;
    const { countryCode, fieldName } = this.state;
    const phoneNumber = this.trimPhoneNumber(value);

    return (
      <TextField
        name={fieldName}
        label={label}
        value={phoneNumber}
        validateField={this._handleValidateField}
        form={form}
        field={field}
        onChange={this._handleChange}
        mask={`${country}Phone`}
        startAdornment={`+${countryCode}`}
        disabled={disabled}
      />
    );
  }
}
export default PhoneField;
